import { SET_LANG_ROUTE } from '../types/types';

const setLangRoute = payload => ({
    type: SET_LANG_ROUTE,
    payload
});

export default setLangRoute;
